import { useCallback } from "react";
import * as Actions from "../actions";
import * as LiveSessionEvents from "../constants/liveSessionEvents";

export const useLiveSessionActions = ({ dispatch }) => {
  const setLiveSessionInitialState = useCallback(
    () => dispatch(Actions.setLiveSessionInitialState()),
    [dispatch]
  );

  const setLocalLiveSessionStreaming = useCallback(
    () => dispatch(Actions.setLocalLiveSessionStreaming()),
    [dispatch]
  );

  const createLiveSession = useCallback(
    (courseId, data) => dispatch(Actions.createLiveSession(courseId, data)),
    [dispatch]
  );

  const setLiveSessionReady = useCallback(
    (liveSessionId) =>
      dispatch(Actions.setLiveSessionState(liveSessionId, LiveSessionEvents.READY)),
    [dispatch]
  );

  const setLiveSessionStreaming = useCallback(
    (liveSessionId) =>
      dispatch(Actions.setLiveSessionState(liveSessionId, LiveSessionEvents.STREAMING)),
    [dispatch]
  );

  const finishLiveSession = useCallback(
    (liveSessionId) =>
      dispatch(Actions.setLiveSessionState(liveSessionId, LiveSessionEvents.FINISH)),
    [dispatch]
  );

  const cancelLiveSession = useCallback(
    (liveSessionId) =>
      dispatch(Actions.setLiveSessionState(liveSessionId, LiveSessionEvents.CANCEL)),
    [dispatch]
  );

  const setLivePageLoading = useCallback(() => dispatch(Actions.setLivePageLoading()), [dispatch]);

  return {
    setLiveSessionInitialState,
    setLocalLiveSessionStreaming,
    createLiveSession,
    setLiveSessionReady,
    setLiveSessionStreaming,
    finishLiveSession,
    cancelLiveSession,
    setLivePageLoading,
  };
};
